var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { id: _vm.modalId, "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _c("i", { staticClass: "glyphicon glyphicon-calendar" }),
                _c("b", [_vm._v(_vm._s(_vm.$t("txtMove")))])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#" + _vm.modalId
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("kanbanBoard")) +
                    "\n                "
                ),
                _c("v-select", {
                  attrs: {
                    options: _vm.state.boards,
                    label: "name",
                    clearable: false
                  },
                  model: {
                    value: _vm.selectedBoard,
                    callback: function($$v) {
                      _vm.selectedBoard = $$v
                    },
                    expression: "selectedBoard"
                  }
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("kanbanFlow")) +
                    "\n                "
                ),
                _c("v-select", {
                  attrs: {
                    options:
                      (_vm.selectedBoard && _vm.selectedBoard.tickets) || [],
                    label: "name",
                    clearable: false
                  },
                  model: {
                    value: _vm.selectedFlow,
                    callback: function($$v) {
                      _vm.selectedFlow = $$v
                    },
                    expression: "selectedFlow"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    "data-dismiss": "modal",
                    disabled: !_vm.selectedFlow
                  },
                  on: { click: _vm.move }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("txtMove")) +
                      "\n                "
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }